module.exports = __webpack_public_path__ + "static/media/bg-crowd.5127ff3b.png";